import { ThemeProvider, createTheme } from "@mui/material";
import { useEffect, useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { useSelector } from "react-redux";
import MainPage from "../Views/Pages/Main";
import DocsPage from "../Views/Pages/Docs";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
const getActiveTheme = (themeMode) => {
  console.log("themeMode: ", themeMode);
  return createTheme({
    pageColor: "#000",
    
    bgPrimary: "#000",
    bgSecondary: "#0C0B0B",

    textPrimary: "#fff",
    textSecondary: "#3B5CFF",

    switchColor: "#b1b1b1",
  });
};
const ThemeContainer = () => {
  const currentTheme = useSelector((state) => state.LDTheme.value);
  const [activeTheme, setActiveTheme] = useState(getActiveTheme(currentTheme));

  useEffect(() => {
    setActiveTheme(getActiveTheme(currentTheme));
  }, [currentTheme]);
  return (
    <ThemeProvider theme={activeTheme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/docs" element={<DocsPage />} />
          <Route path="/docs/:slug" element={<DocsPage />} />
          {/* <Route path="/msg-mask" element={<Mixer />} /> */}
          {/* <Route path="/visa-card" element={<VisaCard />} /> */}

          {/* Add a catch-all route to handle 404 errors */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default ThemeContainer;
